// Ghi giỏ hàng sang `jos_vm_cart` — port `ps_cart::saveCart()`.
//
// Joomla gọi `saveCart()` ở CẢ 8 chỗ đổi giỏ (initCart/add/update/delete/
// replaceCart/mergeSaved/replaceCartToFoProduct/replaceCartToAsoshiProduct), nên
// ở đây bọc `fetch` và bắt mọi mutation `/cart/*.js` thay vì gắn tay từng chỗ gọi:
// thiếu 1 chỗ là batch `MailRemindCart` bỏ sót khách đó, mà batch trả 0 dòng vẫn
// là kết quả hợp lệ nên không ai biết.
//
// Chỉ chạy khi đã login (`saveCart()`: `auth.user_id > 0`), fire-and-forget.

(function () {
  'use strict';

  const MUTATIONS = /\/cart\/(add|change|update|clear)\.js/;
  const SIG_KEY = 'ink_cart_mirror_sig';

  function loggedIn() {
    return customerKey() !== '';
  }

  // Chữ ký phải gắn với CHỦ giỏ: logout của Shopify là link native, không xoá
  // sessionStorage — khách B login sau khách A trên cùng tab mà giỏ không đổi thì
  // chữ ký trùng và giỏ của B không bao giờ được ghi. Cùng lý do api-client.js
  // gắn owner key vào token.
  function customerKey() {
    var cfg = window.INK_API_CONFIG || {};
    var c = cfg.customer;
    return (c && c.id) ? (cfg.shopDomain || '') + '|' + c.id : '';
  }

  let timer = null;
  let pending = false;

  async function push() {
    pending = false;
    if (!loggedIn() || !window.inkApi) return;

    let cart;
    try {
      const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      if (!res.ok) return;
      cart = await res.json();
    } catch (e) {
      return;
    }

    // Line quà (`_gift`) do gift picker quản lý, ¥0 qua ink-discount — không phải
    // 商品 khách chọn nên không vào giỏ mirror.
    const items = (cart.items || [])
      .filter((it) => !(it.properties && it.properties._gift === '1'))
      .filter((it) => it.sku)
      .map((it) => ({ sku: it.sku, qty: it.quantity }));

    try {
      const j = await window.inkApi.post('/cart/mirror', { items });
      // `inkApi` KHÔNG throw trên lỗi HTTP (401 token hết hạn, 5xx…) — nó trả body
      // kèm `error`. Ghi nhận chữ ký ở ca đó là coi như đã mirror xong và
      // `bootSync` sẽ không thử lại nữa ⇒ giỏ của khách này biến mất khỏi
      // `MailRemindCart` cho tới lần đổi giỏ tiếp theo.
      if (j && j.data && typeof j.data.saved !== 'undefined') {
        remember(signature(cart.items || []));
      } else {
        console.warn('[cart-mirror] server từ chối', j && j.error);
      }
    } catch (e) {
      // Mirror lỗi KHÔNG được ảnh hưởng thao tác giỏ của khách — batch mail chỉ
      // trượt 1 nhịp, còn chặn ở đây là mất đơn.
      console.warn('[cart-mirror] sync fail', e);
    }
  }

  function schedule() {
    if (!loggedIn()) return;
    pending = true;
    clearTimeout(timer);
    // Gộp chùm mutation (vd trang giỏ update nhiều dòng 1 lượt) thành 1 request.
    timer = setTimeout(push, 400);
  }

  const origFetch = window.fetch;
  if (typeof origFetch === 'function' && !window.__inkCartMirrorHooked) {
    window.__inkCartMirrorHooked = true;
    window.fetch = function (input, init) {
      const url = typeof input === 'string' ? input : (input && input.url) || '';
      const p = origFetch.apply(this, arguments);
      if (!MUTATIONS.test(url)) return p;

      // Không await trong đường của caller: chỉ nghe kết quả rồi tự đi tiếp.
      p.then((res) => { if (res && res.ok) schedule(); }).catch(() => {});

      return p;
    };
  }

  // Cùng format với `INK_CART_SIG` do layout render bằng Liquid.
  function signature(items) {
    return items.map((it) => (it.sku || '') + ':' + it.quantity).join('|');
  }

  function remember(sig) {
    try { sessionStorage.setItem(SIG_KEY, customerKey() + '||' + sig); } catch (e) { /* bị chặn */ }
  }

  // Đối chiếu chữ ký giỏ do Liquid render (layout) với lần mirror gần nhất:
  //   - giỏ tạo lúc chưa login rồi khách login (Shopify giữ giỏ) — Joomla
  //     `initCart` cũng `saveCart()` ngay khi khôi phục session;
  //   - trang giỏ `location.reload()` sau khi đổi số lượng, cắt mất debounce.
  // Không khớp mới gọi API ⇒ giỏ không đổi thì 0 request.
  function bootSync() {
    if (!loggedIn()) return;
    var sig = customerKey() + '||' + (window.INK_CART_SIG || '');
    var seen = null;
    try { seen = sessionStorage.getItem(SIG_KEY); } catch (e) { /* bị chặn */ }
    if (seen === sig) return;
    push();
  }

  // Mutation vừa xảy ra mà debounce chưa bắn thì chuyến đi tiếp (vd bấm
  // レジへ進む) mất lần ghi đó — chữ ký chưa cập nhật nên `bootSync` của trang
  // sau sẽ bù, đây chỉ là đường nhanh.
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden' && pending) {
      clearTimeout(timer);
      push();
    }
  });

  if (window.inkApi) bootSync();
  else {
    document.addEventListener('ink:api:ready', bootSync, { once: true });
    window.addEventListener('load', () => setTimeout(() => { if (!window.inkApi) bootSync(); }, 1000));
  }
})();
